import React, { useRef, useState, useEffect } from "react";
import { PageLayout } from "../../components/PageLayout";
import { navigate } from "@reach/router";
import { useGistStateValue } from "./context";
import { actions } from "./reducer";

export const NoParam = () => {
  const [state, dispatch] = useGistStateValue();
  useEffect(() => dispatch(actions.clearContent()), []);

  return (
    <PageLayout title={"Gist"}>
      <div className="flex flex-col min-w-full h-full items-center justify-center">
        <div className="flex flex-col justify-center max-w-3xl w-full">
          <p className="text-xl mb-3">Paste a public gist id or url in here.</p>

          <form
            className="flex h-full w-full flex-row items-center mb-3"
            onSubmit={e => {
              e.preventDefault();
              const value = state.inputValue;
              const gistId = getMatch(value);

              if (!gistId) {
                dispatch(actions.setError("Invalid gist url / id!"));
              } else {
                return navigate(`gist/${getMatch(state.inputValue)}`);
              }
            }}
          >
            <input
              type="text"
              value={state.inputValue}
              onChange={e => {
                const inputValue = e.target.value;

                dispatch(actions.inputChange(inputValue));
              }}
              className={`text-lg flex-1 h-full rounded border border-black p-3${
                state.validationError ? " border-red" : ""
              }`}
            />

            <button className="text-3xl rounded border p-3 ml-6 bg-primary text-white">
              Render!
            </button>
          </form>

          <p className="text-red text-lg align-left mb-3">
            {state.validationError || ""}
          </p>
        </div>
      </div>
    </PageLayout>
  );
};

const gistUrlRegexp = /http(s?):\/\/gist\.github\.com\/[a-zA-Z0-9]+\/([a-zA-Z0-9]+)/;
const alphanumericRegexp = /^[a-zA-Z0-9]+$/;

function getMatch(str) {
  const match = gistUrlRegexp.exec(str);

  console.log(match);

  if (match) {
    return match[2];
  } else {
    if (alphanumericRegexp.exec(str)) return str;
  }

  return null;
}
